import Http from "./http";

export const updateAiCampaignStatusAPI = (payload) => {
  return Http.post("admin/campaign/updateStatus", payload);
};
